<template>
  <div style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
              style="margin-left: 10px;"
          ></v-progress-circular>
          <span class="d-flex flex-column">
            <h1>{{this.singular}}: {{this.data.name}}</h1>
            <span>Created By: {{ lookupUsername(data.createdBy) }}</span>
            <span>Created At: {{ utils.formatDate(data.createdAt, 'withTime') }}</span>
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn v-if="isAllowed('device','u')" @click="isEditable = !isEditable">
            <span v-if="this.isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-form :disabled="!isEditable">
        <v-row>
          <v-col>
            <v-text-field
                label="Name"
                outlined
                v-model="data.name"
            />
            <v-textarea
                name="Description"
                label="Description"
                v-model="data.description"
                outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col v-if="isEditable">
          <v-btn @click="update">Save</v-btn>
          <v-btn v-if="isAllowed('device','d')" style="margin-left: 10px;" class="error" @click="deleteData">Delete</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";
import utils from '../../plugins/helpers'

export default {
  data () {
    return {
      utils: utils,
      deleteDialog: false,
      deleteConfirmed: true,
      loader: true,

      snackObj: {
        color: '',
        text: ''
      },

      max25chars: v => v.length <= 25 || 'Input too long!',
      editMode: false,
      data: {device: {}},

      singular: "Appointment Type",
      singularLower: "appointmenttype",
      plural: "Appointment Types",
      pluralLower: "appointmenttypes",

      isEditable: false,
      employees: []
    }
  },
  async mounted(){
    try {
      this.loader = true;
      let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
      if(res.data.error) throw res.data.error

      this.data = res.data.data

    } catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    } finally {
      this.loader = false;
    }
  },
  computed: {
    ...mapGetters(['getEndpoint', "isAllowed", 'lookupUsername'])
  },
  methods: {
    async update(){
      try {
        this.loader = true;
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`, this.data)
        if(res.data.error) throw res.data.error

        this.snack(`${this.singular} info Updated 🎉`, "success")
        this.isEditable = false;
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    async deleteData(){
      try {
        this.loader = true
        let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
        if(res.data.error) throw res.data.error

        this.snack(this.singular+" Deleted 🎉", "success");

        await this.$router.go(-1)
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
  }
}
</script>
